export function getPilotLabel(payload) {
  if (payload.full_name == " ") {
    return `User: #${payload.id} (no name entered!)`;
  } else if (payload.arn == undefined) {
    return payload.full_name;
  } else {
    return `${payload.full_name} (${payload.arn})`;
  }
}
